import classNames from "classnames";
import ReactDOM from "react-dom";
import classes from "./dialog.module.scss";

export const Dialog = ({
  isOpen,
  title,
  description,
  isLoading,
  onConfirm,
  onClose,
  onCancel = onClose,
  cancelText = "Cancel",
  okText = "Yes",
  variant = "",
}) => {
  if (!isOpen) return <></>;
  return ReactDOM.createPortal(
    <div className={classes["dialog"]}>
      <div className={classes["overlay"]} onClick={onClose} />
      <div className={classNames(classes["body"], classes[variant])}>
        <span className={classes["title"]}>{title}</span>
        <span className={classes["description"]}>{description}</span>
        <button
          className={classNames(classes["btn"], {
            [classes["loading"]]: isLoading,
          })}
          onClick={onConfirm}
        >
          {!isLoading && okText}
        </button>
        <span className={classes["cancelBtn"]} onClick={onCancel}>
          {cancelText}
        </span>
      </div>
    </div>,
    document.getElementsByTagName("body")[0]
  );
};
